import { Button } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface LayersButtonProps {
  noBorderTop?: boolean;
}

export const LayersButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'noBorderTop',
})<LayersButtonProps>(({ theme, noBorderTop }) => ({
  width: 40,
  height: 40,
  borderRadius: '4px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.palette.common.white,
    filter: 'brightness(0.8)',
  },
  ...(noBorderTop && {
    borderTop: `0.5px solid ${theme.palette.divider}`,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  }),
}));

export const MenuHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const MenuLoading = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.25),
}));
